<span id="type-icon" class="icon-container">
    <svg class="icon-16">
        <use [attr.href]="iconMap[iconDetail?.iconType]"></use>
    </svg>
</span>
<span class="clip-overflow">{{ text }}</span>